import {Component, OnInit} from '@angular/core';
import {QFilterModel} from '../../../../models/qfilter.model';
import {IndicatorsService} from '../../../../services/indicators/indicators.service';
import {IndicatorBoxModel, IndicatorOtherModel} from '../../../../models/indicator-box.model';
import {IndicatorsSearchToolbarModel} from '../../../../models/indicators-search-toolbar-model.model';
import {TranslateService} from '@ngx-translate/core';
import {TreeNode} from 'primeng/components/common/treenode';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-analysis-single-store-revenue',
  templateUrl: './analysis-single-store-revenue.component.html',
  styleUrls: ['./analysis-single-store-revenue.component.css']
})
export class AnalysisSingleStoreRevenueComponent implements OnInit {

  public data: QFilterModel;

  public indicators: IndicatorBoxModel[] = [];
  public base_tree: TreeNode[];
  public base_tree_legend: TreeNode[];
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

  public storeError = false;
  public selectOneError: string;

  constructor(
    private translate: TranslateService,
    private indicatorService: IndicatorsService
  ) { }

  ngOnInit() {
    this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });
  }

  expandTree(treeArray: Array<IndicatorOtherModel>, keyLevelName: string): TreeNode {
    const node: IndicatorOtherModel = treeArray.find(ind => ind.name === keyLevelName.trim());

    console.log('NEGOZIO ANALISI FATTURATO, PROCESSING' + keyLevelName, node);
    const tnode: TreeNode = {
      data: {
        current: node.current,
        previous: node.previous,
        percent: node.diffPercentage,
        uom: node.unitOfMeasure || '',
      },
      children: [],
      expanded: true,
      label: node.description.replace('.description', ''),
      type: 'node'
    };

    node.other.split(',').forEach(child => {
      if (child.trim() !== 'none') {
        tnode.children.push(this.expandTree(treeArray, child))
      }
    });

    return tnode;
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;
    if (data['stores'] != null) {
      this.translate.get([
        'indicator.fatturato',
        'indicator.scontrini',
        'indicator.fatturato_mq',
        'indicator.scontrino_medio',
        'indicator.media_clienti_settimanali',
        'indicator.incidenza_carta',
        'indicator.incidenza_promo',
        'indicator.nuovi_clienti',
        'common.previous',
        'common.current',
        'common.difference',
        'common.legend'
      ]).subscribe(t => {
        this.indicators = [];

        this.indicatorService.indicatorCalculation('stores.Q077', this.data).subscribe((res) => {
          console.log('Q077', res);

          const fatturato = res.find(ind => ind.name === 'fatturato');
          this.indicators.push(new IndicatorBoxModel([fatturato], {dynamic: true, unit_period_prec: fatturato.unitOfMeasure}, t));

          const scontrini = res.find(ind => ind.name === 'scontrini');
          this.indicators.push(new IndicatorBoxModel([scontrini], {decimal_value: 0, decimal_prec_value: 0, unit_period_prec: scontrini.unitOfMeasure}, t));

          const fatturato_mq = res.find(ind => ind.name === 'fatturato_mq');
          this.indicators.push(new IndicatorBoxModel([fatturato_mq], {decimal_value: 0, decimal_prec_value: 0, unit_period_prec: fatturato_mq.unitOfMeasure}, t));

          const incidenza_carta = res.find(ind => ind.name === 'incidenza_carta');
          this.indicators.push(new IndicatorBoxModel([incidenza_carta], {unit_period_prec: incidenza_carta.unitOfMeasure}, t));

        });

        this.indicatorService.indicatorCalculationOther('stores.Q0901', this.data).switchMap((res) => {
          const legenda: TreeNode = {
            data: {
              current: t['common.current'],
              previous: t['common.previous'],
              percent: t['common.difference'],
              type: 'legend',
            },
            children: [],
            expanded: true,
            label: t['common.legend'],
            type: 'node'
          };

          this.base_tree = [this.expandTree(res, 'fatturato')];
          return Observable.of(legenda);
        }).subscribe(res => {
          this.base_tree_legend = [res];
        });

      });
    } else {
      this.data = null;
      this.storeError = true;
    }
  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  public resetData() {
    this.data = null;
    this.indicators = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis-single-store-revenue/analysis-single-store-revenue.component.ts